import { Component, Input } from "@angular/core";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-no-data-msg",
  templateUrl: "./no-data-msg.component.html",
  styleUrls: ["./no-data-msg.component.css"],
})
export class NoDataMsgComponent {
  @Input()
  public message: string = "No hay datos para mostrar";
  // icons
  protected faFolderOpen = faFolderOpen;
}
